// extracted by mini-css-extract-plugin
export default {"productDescription":"x--z","featuredDescription":"y--z","description":"z--z","more":"A--z","descriptionSku":"B--z"};